import { CardBrand } from '../../../models';
import americanExpress from '../../icons/payment-cards/american-express.svg';
import dinersClub from '../../icons/payment-cards/diners-club.svg';
import discover from '../../icons/payment-cards/discover.svg';
import jcb from '../../icons/payment-cards/jcb.svg';
import masterCard from '../../icons/payment-cards/master-card.svg';
import unionPay from '../../icons/payment-cards/union-pay.svg';
import visa from '../../icons/payment-cards/visa.svg';

export const CARD_BRAND_LIST: CardBrand[] = [
  {
    src: visa,
    brand: 'visa',
  },
  {
    src: jcb,
    brand: 'jcb',
  },
  {
    src: masterCard,
    brand: 'mastercard',
  },
  {
    src: dinersClub,
    brand: 'dinersclub',
  },
  {
    src: discover,
    brand: 'discover',
  },
  {
    src: americanExpress,
    brand: 'americanexpress',
  },
  {
    src: unionPay,
    brand: 'unionpay',
  },
];
